import React from 'react';
import Image from './carouselImage';
import {Motion, spring} from 'react-motion';


// https://www.google.com/maps/@39.774769,-74.86084,15z

const springSettings = {stiffness: 170, damping: 23};


export default class Carousel extends React.Component{

  constructor(props) {
     super(props);
     this.state = {position: 0,   size: [500, 500 ] , display : false};
     this.updateDimensions = this.updateDimensions.bind(this);
   }

   updateDimensions() {
        // this.setState({width: window.innerHeight, height: window.innerWidth});
        this.setState({size: [window.innerWidth, window.innerHeight*.50], display: true});
    }

  componentDidMount(){

    window.addEventListener("resize", this.updateDimensions);

    this.setState({size: [window.innerWidth, window.innerHeight*.50], display: true});

    var length = this.props.venueImages.length;

    if(length > 1) {
      var intervalId = setInterval( () => {
        if(this.state.position == length -1 ){
          this.setState({position: 0});
        }else{
            this.setState({position: this.state.position+1 });
        }
      },5000);
       this.setState({intervalId: intervalId});
    }
   }

   componentWillUnmount(){
     clearInterval(this.state.intervalId);
      window.removeEventListener("resize", this.updateDimensions);
   }

  render(){
    const {position, size} = this.state;
    const [currWidth, currHeight] = size;

    var height = this.props.viewport ? 220: currHeight;

    const widths = this.props.venueImages.map((i) => currWidth);
    const leftStartCoords = widths
          .slice(0, position)
          .reduce((sum, width) => sum - width, 0);

       let configs = [];
           widths.reduce((prevLeft, width , i) => {
             configs.push({
               left: spring(prevLeft, springSettings),
               height: spring(height, springSettings),
               width: spring(widths[i], springSettings),
             });
             return prevLeft + widths[i];
           }, leftStartCoords);

    return (
      <div className="offer-carousel">

        { this.state.display ?
        <Motion style={{height: spring(height), width: spring(currWidth)}}>
          {container =>
            <div className="gallery-container" style={container}>
              {configs.map((style, i) =>
                <Motion key={i} style={style}>
                  {style =>
                  <Image  src={this.props.venueImages[i]}
                          style={style}
                          viewport = {this.props.viewport}
                          name = {this.props.name+i}/>
                  }
                </Motion>
              )}
            </div>
          }
        </Motion> : <span/>
       }

       </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Offer-detail-page/ImageGallery/carousel.js